import { putMany, deleteBy } from './db.js';

export async function mergeRoster(db, payload) {
  const { families = [], people = [], handovers = [] } = payload || {};
  const [alive, dead] = handovers.reduce(
    ([a, d], h) => (h.voided_at ? [a, [...d, h]] : [[...a, h], d]),
    [[], []],
  );
  await putMany(db, 'families', families);
  await putMany(db, 'people', people);
  await putMany(db, 'handovers', alive);
  for (const h of dead) await deleteBy(db, 'handovers', h.id);
  return {
    familiesUpserted: families.length,
    peopleUpserted: people.length,
    handoversUpserted: alive.length,
  };
}
